import Vue from 'vue'
import VueRouter from 'vue-router'
import { addLog } from '../utils/api/log'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    component: () => import('../views/index.vue'),
    redirect: '/index', //设置默认指向的路径
  },
  //首页
  {
    path: '/index',
    name: '首页',
    component: () => import('../views/index.vue'),
  },
  //价格行情
  {
    path: '/priceQuotation',
    name: '价格行情',
    component: () => import('../views/priceQuotation.vue'),
  },
  //金融保险
  {
    path: '/financialInsurance',
    name: '金融保险',
    component: () => import('../views/financialInsurance.vue'),

  },

  //金融服务申请规则
  {
    path: '/financialInsuranceApplyForRules',
    name: '金融服务申请规则',
    component: () => import('../views/financialInsuranceApplyForRules.vue'),
  },
  //金融服务申请
  {
    path: '/financialInsuranceApplyFor',
    name: '金融服务申请',
    component: () => import('../views/financialInsuranceApplyFor.vue'),
  },
  //保险服务
  {
    path: '/insurance',
    name: '保险服务',
    component: () => import('../views/insurance.vue'),
  },
  {
    path: "/insuranceDetail",
    name: '金融保险详情',
    component: () => import('../views/insuranceDetail.vue')
  },
  // 交易撮合
  {
    path: '/dealmakers',
    name: '交易撮合',
    component: () => import('../views/dealmakers.vue'),
  },


  // 交易详情
  {
    path: '/dealmakersDetails',
    name: '交易详情',
    component: () => import('../views/dealmakersDetails.vue'),
  },
  // 撮合详情
  {
    path: '/matchUpDetails',
    name: '撮合详情',
    component: () => import('../views/matchUpDetails.vue'),
  },
  // 专业信息咨询
  {
    path: '/professionalInfoConsultation',
    name: '专业信息咨询',
    component: () => import('../views/professionalInfoConsultation.vue'),
  },
  // 农资采集详情
  {
    path: '/professionalInfoConsultationBuyTea',
    name: '农资采集详情',
    component: () => import('../views/professionalInfoConsultationBuyTea.vue'),
  },
  // 专业技术咨询详情
  {
    path: '/professionalInfoConsultationAdvisoryDetails',
    name: '专业技术咨询详情',
    component: () => import('../views/professionalInfoConsultationAdvisoryDetails.vue'),
  },
  // 信息资讯
  {
    path: '/information',
    name: '信息资讯',
    component: () => import('../views/information.vue'),
  },
  // 信息资讯详情
  {
    path: '/informationDetail',
    name: '信息资讯详情',
    component: () => import('../views/informationDetail.vue'),
  },
  // 个人中心
  {
    path: '/personalCenter',
    name: '个人中心',
    component: () => import('../views/personalCenter.vue'),
  },
  // 病虫害
  {
    path: '/diseasesInsectPests',
    name: '病虫害页面',
    component: () => import('../views/diseasesInsectPests.vue'),
  },
  // 病虫害详情
  {
    path: '/diseasesInsectPestsDetail',
    name: '病虫害详情',
    component: () => import('../views/diseasesInsectPestsDetail.vue'),
  },
  // 病虫害详情
  {
    path: '/resourceLibrary',
    name: '病虫害资源库',
    component: () => import('../views/resourceLibrary.vue'),
  },
  {
    path: '/resourceLibraryDetail',
    name: '病虫害资源库详情',
    component: () => import('../views/resourceLibraryDetail.vue'),
  },
  {
    path: '/agriculture',
    name: '农技技术',
    component: () => import('../views/agriculture.vue'),
  },
  {
    path: '/agricultureDetails',
    name: '农技技术详情',
    component: () => import('../views/agricultureDetails.vue'),
  },
  {
    path: '/modelApplication',
    name: '模型应用',
    component: () => import('../views/modelApplication.vue'),
  },
  
]

const router = new VueRouter({
  routes
});

//要添加的代码
router.beforeEach((to, from, next) => {
  if (to.name) {
    addLog({
      logAction: "页面访问",
      logClass: to.path,
      logModule: to.name,
      logType: "4",
      systemName: "福安茶叶社会化服务平台"
    }).then(res => {
      console.log(res);
    }).catch(error => {
      console.log(error);
    })
  }
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

export default router
